module.exports = {
      id: "video-icon-usage",
      viewBox: "0 0 92 92",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#video-icon",
      toString: function () {
        return this.url;
      }
    }